import React from 'react';
import { Box, Link, Typography } from '@mui/material';
import OverseasInquiryForm from '../../components/en/OverseasInquiryForm';
import { brown, intlPhone, orange, useEnglishPage } from './enCommon';

/* 영문 문의 (/en/center) — 해외 손님은 메일로 받는다. 글을 고치면 prerender 의 EN_CONTACT 도 */
export const EN_CONTACT_TITLE = 'Get a Quote — Charter Bus in Korea | EK Hana Tour';
export const EN_CONTACT_DESC =
  'Send us your travel dates, places and group size, attach your itinerary, and we will email you a charter bus quotation for your trip in Korea.';

export default function EnCenter({ companyData = {} }) {
  useEnglishPage(EN_CONTACT_TITLE, EN_CONTACT_DESC);
  const email = companyData.email || '';
  const tel = intlPhone(companyData.tel);

  return (
    <Box component='main' lang='en' sx={{ maxWidth: 900, mx: 'auto', px: { xs: 2, md: 3 }, py: { xs: 3, md: 5 } }}>
      <Typography component='h1' sx={{ fontSize: { xs: 24, md: 34 }, fontWeight: 800, color: brown, textAlign: 'center' }}>
        Get a quote by email
      </Typography>
      <Typography sx={{ mt: 1.5, color: brown, textAlign: 'center', lineHeight: 1.7 }}>
        Tell us about your trip below — the more detail, the more accurate the quote.
        <br />We reply <b>by email</b> in English. You can attach your itinerary or passenger list (up to 5 MB).
      </Typography>

      <Box sx={{ mt: 3, p: 2, border: `1px solid ${orange}`, borderRadius: 2, bgcolor: '#FFFDF6', color: brown, fontSize: 15 }}>
        <Typography sx={{ fontWeight: 800 }}>Prefer email?</Typography>
        <Typography sx={{ mt: 0.5 }}>
          {email ? (
            <>Send your plan to <Link href={`mailto:${email}`} sx={{ color: orange, fontWeight: 700 }}>{email}</Link>. </>
          ) : 'You can also email us directly. '}
          {tel && <>Phone (Korean business hours): {tel}</>}
        </Typography>
      </Box>

      <Box sx={{ mt: 3 }}>
        <OverseasInquiryForm />
      </Box>
    </Box>
  );
}
